import AddToRegistryButton from './add-to-registry-button'

export default AddToRegistryButton
